import { useQuery } from '@tanstack/react-query';
import { getGlobalFieldBindingCatalogue } from '@dealstack/frontend/shared/dataExchange/services/documentTemplates.service';

// Deliberately not keyed by templateId. There is no deal and no investor at global level, so
// every template resolves the same catalogue against the same sample data — keying per template
// would refetch an identical payload each time one is opened. The id still goes in the request:
// the route is scoped like its field-binding siblings.
export const GLOBAL_DATA_POINT_CATALOGUE_QUERY_KEY = 'global-field-binding-catalogue';

export const useGlobalDataPointCatalogueQuery = (templateId: string | null) =>
	useQuery({
		queryKey: [GLOBAL_DATA_POINT_CATALOGUE_QUERY_KEY],
		queryFn: () => getGlobalFieldBindingCatalogue(templateId ?? ''),
		enabled: !!templateId,
	});
